import ChatsPanel from "./ChatsPanel";

export default ChatsPanel;